let config = {};

if(process.env.NODE_ENV === 'development') {
  config = {
    CLERK_PUBLISHABLE_KEY: 'pk_test_cGlja2VkLWNvcmdpLTY0LmNsZXJrLmFjY291bnRzLmRldiQ',
    STRIPE_PUBLIC_KEY: 'pk_test_51N2qI3JMJO80bdE6L36BP8QMlXdfuN60KXg7aas2IQae5KVITllTSOEUSsruBdp7QxcO31ZcfoW0ypWCepA63Hsx000pgqhc7j',
    SITE_URL: 'http://localhost:4000/',
    APP_URL: 'http://localhost:3000/',
    API_URL: 'http://localhost:8080/'
  };

} else{
  config = {
    CLERK_PUBLISHABLE_KEY: 'pk_live_Y2xlcmsucmV0YWludXIuY29tJA',
    STRIPE_PUBLIC_KEY: 'pk_live_51N2qI3JMJO80bdE6JtzhPrjHc2suetCSehU8B5Pza53a5v8ozzUFfTjrkQW6KOTgnp2wWf6Xj4VBC5EyQ6kZ9hzf00M3HWjeL3',
    SITE_URL: 'https://retainur.com/',
    APP_URL: 'https://retainur.com/app/',
    API_URL: 'https://api.retainur.com/'
  };

}
  
export default config;
